import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-onlineteaching',
  templateUrl: './onlineteaching.component.html',
  styleUrls: ['./onlineteaching.component.css']
})
export class OnlineteachingComponent implements OnInit {

  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

  ngOnInit() {
this.GetOnlineTeaching();
  }
  SearchModel = {    
    StaffID:0,
    ClassID:0,
    SectionID:0,
  };
TeachingLearningList=[];
GetOnlineTeaching() {
  this.spinnerService.show();
  this.learningservice.GetOnlineTeaching(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.TeachingLearningList = data.TeachingLearningList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};

TopicList=[];
ChapterHeading:any;
BookTitle:any;
GetOnlineTeachingTopic(item,BookTitle) {
  this.ChapterHeading=item.ChapterHeading;
  this.BookTitle=BookTitle;
  var itembo={
    ChapterID:item.ChapterID,
   
  }
  this.spinnerService.show();
  this.learningservice.GetOnlineTeachingTopic(JSON.stringify(itembo)).subscribe((data: any) => {
    this.TopicList = data.TopicList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};
safeSrc: SafeResourceUrl;
// embedURL(url){
  
//   let stringToSplit = url;  
//   let x = stringToSplit.split("https://www.youtube.com/watch?v=");
//   var safeSrc="https://www.youtube.com/embed/"+x[1]+"?loop=1"+"&origin=1&rel=1&showinfo=1"
//   return this._sanitizer.bypassSecurityTrustResourceUrl(safeSrc);

  
 
// }

item:any;
DocumentType:any;
DocumentList:any;
mGetTeachingLearningDetails(item,DocumentType){
 this.item=item;
 this.DocumentType=DocumentType;
 var itembo={
  TopicID:this.item.TopicID,
  DocumentType: this.DocumentType,
 
}
this.spinnerService.show();
this.learningservice.GetTeachingDetails(JSON.stringify(itembo)).subscribe((data: any) => {
  this.DocumentList = data.DocumentList;
  if(this.DocumentList){
    for (var i = 0; i < this.DocumentList.length; i++) {
        let stringToSplit = this.DocumentList[i].ResourcePath;  
  let x = stringToSplit.split("https://www.youtube.com/watch?v=");
  var safeSrc="https://www.youtube.com/embed/"+x[1]+"?loop=1"+"&origin=1&rel=1&showinfo=1"
  
 this.DocumentList[i].ResourcePath=this._sanitizer.bypassSecurityTrustResourceUrl(safeSrc); 

            }
   
   }
  this.spinnerService.hide();
  this.globalHelper.CheckActionStatus(data);
});
}
}
